import { sysList } from '@/api/setting/sys'
import { areaList } from '@/api/setting/area'
import { streetList } from '@/api/setting/street'
import houseApi from '@/api/system/houses/house.js'

export const singleSelectMixin = {
  data () {
    return {
      
      queryArea: {
        areaName: undefined, //	名称
        level: 3, // 等级（1：省 2：市 3：区）
        parentId: undefined //	父类ID
      },
      // 区域
      region: [],
      // districtList: [],

      queryBusinessDisParam: {
        businessDistrictName: undefined, // 商圈名称
        districtId: undefined // 区域ID
      },
      // businessDistrictList: [],

      queryStreetParam: {
        businessDistrictId: undefined, //	商圈ID
        streetFullName: undefined // 街道全称
      },
      valueData:'',
      StreetData: [], //存储所有街道信息

    }
  },
  methods: {
    // 商圈的搜索
    businessDisSearch (value) {
      this.queryBusinessDisParam.districtId = undefined
      this.queryBusinessDisParam.businessDistrictName = value
      this.getBusinessDistrictList(this.queryBusinessDisParam, null)
    },
    onEnterPress(){
      console.log('商圈')
      this.getBusinessDistrictList(this.queryBusinessDisParam, null)
    },
    // 根据商圈改变事件
    businessDistrictMethod (val, pageName) {
      this.form.streetName = ''
      this.form.communityName = undefined
      this.form.houseFloor = undefined

      this.form.streetId = undefined
      this.form.streetName = undefined

      const businessDis = this.businessDistrict.find((item) => {
        return item.id === val
      })
      this.form.businessDistrictName = businessDis.businessDistrictName
      console.log(businessDis.districId + '----')
      // 区域
      this.form.districtId = businessDis.districId
      this.form.businessDistrictId = businessDis.id
      this.getDistrictBusinessInfo(this.form.districtId)

      this.getStreetMethod()
      this.validateCon(pageName)
      // this.getSearchHouseMsg()
    },
    // 获取街道
    getStreetMethod (status) {
      console.log(status,'22222222222')
      if (status === 'init') {
        this.getStreetList(() => {
          if (this.getDoorNumData) {
            if (this.form.streetId) {
              this.getDoorNumData(this.form.streetId)
            }
          }
        })
      } else {
         this.getStreetList()
          // 重置门牌号、附号信息
          this.resetHouseNumber()
      }
    },
    // 街道的搜索
    streetSearch (value) {
      this.valueData=value
      this.queryStreetParam.businessDistrictId = undefined //	商圈ID
      this.queryStreetParam.streetFullName = value
    },
    onEnterStreet(e){
      if(this.valueData){
        this.getStreetdataS()
      }
    },
    //获取街道信息
    getStreetdataS(){
      streetList(this.queryStreetParam).then((response) => {
        if (response.code === 200) {
          const list = response.data
          this.StreetDataHundred= (JSON.parse(JSON.stringify(list))).slice(0, 100)
          this.StreetData = JSON.parse(JSON.stringify(list))
        }
      })
    },
     // 获取街道id StreetMethod
    StreetMethod (val, pageName) {
      //  console.log(val, this.StreetData)
      this.form.communityName = undefined
      this.form.houseFloor = undefined
      this.form.houseNumber = undefined
      this.form.houseNumberDeputy = undefined
      const newStreet = this.StreetData.find((item) => {
        return item.id === val
      })
      // console.log('newStreet', newStreet)
      this.form.streetName = newStreet.streetFullName
      const businessDisVo = newStreet.businessDistrictVo
      // 区域
      this.form.districtId = newStreet.districtId
      this.getDistrictBusinessInfo(this.form.districtId)
      // 商圈
      this.form.businessDistrictId = businessDisVo.id
      this.form.businessDistrictName = businessDisVo.businessDistrictName
      this.getStreetList()
      if (pageName === 'addRentTourist') { // 租客

      } else if (pageName === 'addSaleTourist') { // 售客

      } else if (pageName === 'addRentHouse') { // 租房
        this.getDoorNumData(this.form.streetId)
        this.getSearchHouseMsg()
      } else if (pageName === 'addSaleHouse') { // 售房
        this.getDoorNumData(this.form.streetId)
        this.getSearchHouseMsg()
      }
    },
    // 根据区域id，获取区域、商圈信息（通过街道反查信息）
    getDistrictBusinessInfo (districtId) {
      // console.log(this.region, districtId)
      const regionChild = this.region.find((item) => {
        // console.log(item.areaId, districtId, item.areaId === districtId)
        return item.areaId === districtId
      })
      console.log('regionChild', regionChild)
      this.form.districtName = (regionChild&&regionChild.areaName)
      this.getBusinessDistrictList({ businessDistrictName: '', districtId: regionChild.areaId }, null)
    },
    // 获取商圈列表
    getBusinessDistrictList (data, func) {
      houseApi.businessDistrict(data).then((res) => {
        if (res.code === 200) {
          this.businessDistrict = res.data
          if (func) {
            func()
          }
        }
      })
    },
    // 获取街道列表
    getStreetList (func) {
      const params = {
        businessDistrictId: this.form.businessDistrictId,
        streetFullName: '',
        streetShortName: ''
      }
      houseApi.GetStreetList(params).then((res) => {
        if (res.code === 200) {
          this.StreetData = res.data
          // console.log(this.form.streetId, this.form.businessDistrictId)
          const street = this.StreetData.filter((item) => {
              return item.id === this.form.streetId
          })
          this.form.streetName = street && street.length > 0 ? street[0].streetFullName : undefined

          const businessDis = this.businessDistrict.filter((item) => {
            return item.id === this.form.businessDistrictId
          })
          this.form.businessDistrictName = businessDis && businessDis.length > 0 ? businessDis[0].businessDistrictName : undefined
          if (func) {
            func()
          }
        }
      })
    },
    // 根据门牌号id获取附号信息
    initHouseNumberDeputyMethod (val) {
      for (const item of this.doorNumData) {
        if (item.houseNumber === val) {
          this.attachedNumberData = item.attachedList
          this.form.houseNumberId = item.attachedList[0].id
          // this.form.houseNumberDeputyId = item.attachedList[0].id
          // this.form.houseNumberDeputy = item.attachedList[0].attachedNumber
          // // 执行附号改变事件
          // this.houseNumberDeputyChange(item.attachedList[0].attachedNumber)
        }
      }
    },
    // 区域列表
    getDistrict (pageName, status) {
      let companyInfo = localStorage.getItem('companyInfo')
      companyInfo = JSON.parse(companyInfo)
      if (companyInfo) {
        this.queryArea.parentId = companyInfo.companyCityId
        this.getArea(pageName, status)
      } else {
        this.getCompanyInfo(() => {
          this.getArea(pageName, status)
        })
      }
    },
    getCompanyInfo (func) {
      const param = { pageNum: 1, pageSize: 1 }
      sysList(param).then((response) => {
        if (response.code === 200) {
          const resData_ = response.data
          this.total = resData_.total
          if (this.total > 0) {
            this.list = resData_.records
            this.dataObj = resData_.records[0]
            this.sys = this.dataObj
            localStorage.setItem('companyInfo', this.sys)
            this.queryArea.parentId = this.sys.companyCityId
            if (func) {
              func()
            }
          } else {
            this.queryArea.parentId = ''
            this.$message.error('公司设置所在市信息获取失败')
          }
        }
      })
    },

    getArea (pageName, status) {
      areaList(this.queryArea).then((res) => {
        if (res.code === 200) {
          const resData = res.data
          const areaList = []
          if (resData != null && resData.length > 0) {
            for (let i = 0; i < resData.length; i++) {
              areaList.push({ areaId: resData[i].areaId, areaName: resData[i].areaName, children: [] })
            }
            this.region = areaList
            // console.log(this.region)
            // console.log(this.form)
            this.regionChange(this.form.districtId, pageName, status)
          }
        }
      })
    },
     // 获取区域ID
    regionChange (val, pageName, status) {
      //  console.log('------------', val, pageName)
      this.form.businessDistrictName = ''
      this.form.streetName = ''
      this.form.communityName = undefined
      this.form.houseFloor = undefined
      const regionChild = this.region.find((item) => {
        return item.areaId === val
      })
      this.form.districtName = regionChild ?  (regionChild&&regionChild.areaName) : undefined
      if (status === 'init') {
      } else {
        // 重置
        this.form.businessDistrictId = undefined
        this.form.businessDistrictName = undefined
        this.form.streetId = undefined
        this.form.streetName = undefined

        this.form.businessDistrictName = undefined
      }
      const areaId = regionChild ? regionChild.areaId : undefined
      this.getBusDistrict({ businessDistrictName: '', districtId: areaId }, status)

      this.validateCon(pageName)
    },
     // 获取商圈
     getBusDistrict (data, status) {
      houseApi.businessDistrict(data).then((res) => {
        if (res.code === 200) {
          this.businessDistrict = res.data
          // this.getStreetMethod(status)
        }
      })
    },
    validateCon (pageName) {
      if (pageName === 'addRentTourist') { // 租客

      } else if (pageName === 'addSaleTourist') { // 售客

      } else if (pageName === 'addRentHouse') { // 租房
        this.getSearchHouseMsg()
      } else if (pageName === 'addSaleHouse') { // 售房
        this.getSearchHouseMsg()
      }
    },
    // 重置门牌号、附号信息
    resetHouseNumber () {
      this.form.houseNumber = undefined
      this.form.houseNumberId = undefined
      this.form.houseNumberDeputy = undefined
      this.form.houseNumberDeputyId = undefined
    }
  },
  created () {
    //  // 区域列表
    // this.getDistrict(null, null)
  }

}
